<!--
 - Author : wanghongling.
 - Date   : 2020/12/23.
 - File   : dailyList.名厨亮灶日巡查清单
 -->

<template>
  <layer title="日巡查清单" titleClass="01" width="326px" padding="15px 20px">
    <my-pie :id="'pie1'+Math.random()" :pieList="dailyPieList"></my-pie>
  </layer>
</template>

<script>
  export default {
    name: 'dailyList',
    data () {
      return {
        departmentId: '',
        dailyPieList: {
          name: '',
          width: '100%',
          margin: '-45px auto 0px',
          height: '240px',
          radius: ['37%', '57%'],
          newLine: '\n',
          title: '0',
          subTitle: '总检查项',
          startAngle: 90,
          dw: '件',
          legendType: 3,
          per: true,
          labelShow: false,
          color: ['#df6400', '#00c900', '#ef6c6c', '#0d90f8'],
          data: [
            {
              name: '未检查',
              per: '0%',
              value: 0
            },
            {
              name: '已检查',
              per: '0%',
              value: 0
            }
          ]
        }
      }
    },
    watch: {
      selectDeptId: {
        handler(cur) {
          this.departmentId = cur
          this.getDailyList()
        },
        deep: true
      }
    },
    props: ['selectDeptId'],
    mounted() {
      if(this.departmentId) {
        this.getDailyList()
      }
      this.dailyWsMsg()
    },
    methods: {
      /**
       * @author wanghongling
       * @createTime 2020/12/24
       * @description websocket监听数据
       */
      dailyWsMsg () {
        window.getDailyInfo = e => {
          console.log(e, 'websocket监听数据')
          this.getDailyList()
        }
      },
      /**
       * @Description:获取名厨亮灶日巡查清单
       * @author wanghongling
       * @createDate 2020/12/24
      */
      getDailyList() {
        this.$request.inspectmenuStatisticsDeptGet({departmentId: this.departmentId}).then(res => {
          console.log('获取名厨亮灶日巡查清单', res)
          if(!this.$utils.isEmptyObject(res)) {
            let data = []
            let per1 = res.totalNum === 0 ? '0%' : (res.alreadyNum / res.totalNum).toFixed(1) * 100 + '%'
            let per2 = res.totalNum === 0 ? '0%' : (res.noCheckNum / res.totalNum).toFixed(1) * 100 + '%'
            let obj1 = {
              name: '未检查',
              per: per1,
              value: res.noCheckNum
            }
            let obj2 = {
              name: '已检查',
              per: per2,
              value: res.alreadyNum
            }
            data = data.concat(obj1, obj2)
            this.dailyPieList.data = data
            this.dailyPieList.title = res.totalNum === 0 ? '0' : res.totalNum
          }
        }).catch(e => {
          console.error(e)
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/mingChu/dailyList.vue